import { FC } from 'react'
import theme from 'theme'
import { ThemeButton } from '../../../../components/buttons'
import WeightsIcon from '../../../../components/svg/WeightsIcon'

interface Props {
  onClick: () => void
  disabled?: boolean
}

const EvenWeightButton: FC<Props> = ({ onClick, disabled }) => (
  <ThemeButton
    themevariant="secondary"
    onClick={onClick}
    disabled={disabled}
    sx={{ paddingRight: `${theme.spacing.medium}px !important`, whiteSpace: 'nowrap' }}
  >
    <>
      <WeightsIcon />
      Even Weights
    </>
  </ThemeButton>
)

export default EvenWeightButton
